import React, { CSSProperties, FC } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { LKDate } from 'loankeeper-common/helpers/Date'

//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'
import { withUserConfig } from 'shared'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
// import HistoryModal, { HISTORY_MODAL } from 'shared/HistoryModal'
//@ts-ignore
import LoanTransactionDisburse, { LoanTransactionDisburseTrigger } from 'shared/Modals/LoanTransactionDisburse'

import HistoryModal, { HISTORY_MODAL } from 'src/features/shared/HistoryModalNew'

import { prevFetch } from 'loankeeper-common/helpers/SimpleFetchManager'
import { LoanCoverTrigger } from '../../../LoanCover'
import { actions as DCActions } from '../../../DetailsContainer'
import { pages } from './constants'
import translator, { translateTransactions, translateLKMessage } from '../../translator'

import { TransactionsProps, TransactionData, MemoizedLKGridProps } from '../../types.LoanDetails'
import { deleteTransaction, loanView } from 'src/store/loan'

import { AppDispatch } from 'src/store/index.d'

const searchAgainLoans = () => prevFetch({ instanceName: 'LOANS' })

const getGridConfig = () => ({
  gridIdentity: {
    formName: 'frm_loan_transactions',
    objectName: 'grd_transactions',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,
  enableRowSelection: true,
  selectLastRow: true,

  columnConfigs: {
    Amount: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OperDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    EntryID: {
      cellStyle: { textAlign: 'right' },
    },
  },
})

function reload(ID: string, hash: string, page: string) {
  return DCActions.fetchPage({
    type: 'Loan',
    ID,
    hash,
    page,
  })
}

const MemoizedLKGrid: FC<MemoizedLKGridProps> = (props) => {
  const { instanceName, rowData, getContextMenuItems, onRowDoubleClicked, getRowStyle } = props
  const config = React.useMemo(() => getGridConfig(), [])

  return (
    <LKGrid
      instanceName={instanceName}
      rowData={rowData}
      getContextMenuItems={getContextMenuItems}
      onRowDoubleClicked={onRowDoubleClicked}
      getRowStyle={getRowStyle}
      {...config}
    />
  )
}

@withRouter
@withLivedata('OpenDayStatus.Open_Day as OpenDay')
@withUserConfig('ID as UserID')
@withConstantPermissions()
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch, ownProps: TransactionsProps) => ({
  searchAgainLoans: () => {
    dispatch(searchAgainLoans())
  },
  onRefresh: () => {
    dispatch(reload(ownProps.ID, ownProps.hash, 'base'))
    dispatch(reload(ownProps.ID, ownProps.hash, 'reserveauto'))
    dispatch(reload(ownProps.ID, ownProps.hash, 'reserveman'))
  },
  openDeleteTransaction: (ID: number, hash: string, OperDate: string) => {
    if (ownProps.OpenDay !== OperDate) {
      dispatch(
        LKModalActions.openConfirmation('DELETE_TRANS_AGREE', {
          message: translateLKMessage('CONFIRM_OPER_CLOSED_DAYS'),
          ID,
          hash,
        }),
      )
    } else {
      dispatch(LKModalActions.openConfirmation('DELETE_TRANS', { ID, hash }))
    }
  },
  // openHistory: (args: any) => {
  //   dispatch(LKModalActions.open({ ID: ownProps.ID, hash: ownProps.hash, name: HISTORY_MODAL, ...args }))
  // },
  openHistory: (args: Record<string, any>) => {
    dispatch(LKModalActions.open({ name: HISTORY_MODAL, LoanID: ownProps.ID, HashSum_LoanID_: ownProps.hash, ...args }))
  },
  onLoanDisburseCallbackActions: () => {
    //@ts-ignore
    dispatch([
      ownProps.fetchOperations(),
      DCActions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'transactions' }),
      DCActions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'base' }),
    ])
  },

  deleteTransaction: async (
    id: number,
    hash: string,
    setLoading: (loading: boolean) => void,
    onRefresh: () => void,
    searchAgainLoans: () => void,
  ) => {
    setLoading(true)
    try {
      // await Loan.deleteTransaction({
      //   LoanID: ownProps.ID,
      //   HashSum_LoanID_: ownProps.hash,
      //   OperationID: id,
      //   HashSum_OperationID_: hash,
      // })

      //UPDATED API REQUEST loan_oper_api page: transactiondelete
      const result = await dispatch(
        deleteTransaction({
          LoanID: ownProps.ID,
          HashSum_LoanID_: ownProps.hash,
          OperationID: id,
          HashSum_OperationID_: hash,
        }),
      )

      if (!deleteTransaction.fulfilled.match(result)) {
        throw { Error: { Message: result.payload } }
      }

      dispatch(ownProps.fetchOperations())
      dispatch(DCActions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'transactions' }))

      if (ownProps.base.StateID === 2 || ownProps.data.length === 1) {
        dispatch(DCActions.fetchPage({ type: 'Loan', ID: ownProps.ID, hash: ownProps.hash, page: 'base' }))
      }

      searchAgainLoans()
    } catch (e) {
      dispatch(LKModalActions.openError(translateLKMessage(e.Error.Message || e.Error.Text)))
    } finally {
      setLoading(false)
    }
  },
}))
class Transactions extends React.Component<TransactionsProps> {
  state = { loading: false }

  onRowDoubleClicked: any

  getStylesForRow = ({
    node: {
      data: { OperDate },
    },
  }): CSSProperties => {
    if (moment(OperDate).isBefore(this.props.OpenDay)) {
      return { backgroundColor: 'gray' }
    }
  }

  pushOrderDetails = (EntryID: number, HashSum_EntryID_: string, EntryOperTypeID: number) => {
    this.props.history.push(`/secure/order/${EntryID}/details/${HashSum_EntryID_}/${EntryOperTypeID}`)
  }

  setLoading = (loading: boolean) => this.setState({ loading })

  getContextMenuItems = (params: { node: { data: TransactionData } }) => {
    const {
      node: {
        data: { ID, HashSum_OperationID_, OperDate, EntryID, HashSum_EntryID_, EntryOperTypeID, SEC_UserID },
      },
    } = params

    return [
      this.props.permissions.ACC_ENTRIES_VIEW
        ? {
            name: translateTransactions('cmd_view_entry'),
            icon: 'info',
            action: () => {
              this.pushOrderDetails(EntryID, HashSum_EntryID_, EntryOperTypeID)
            },
            disabled: !EntryOperTypeID || !HashSum_EntryID_,
          }
        : undefined,
      this.props.base.IsArrested !== 1 &&
      (this.props.permissions.LOANOPER_ENTRIES_DELETE_ALIEN || SEC_UserID === this.props.UserID)
        ? {
            name: translateTransactions('cmd_delete'),
            icon: 'delete',
            action: () => {
              this.props.openDeleteTransaction(ID, HashSum_OperationID_, OperDate)
            },
            permissionKey: `DELETE_LOAN_TRANSACTION${this.props.base.ProductType === 4 ? '_LMB' : ''}`,
          }
        : undefined,
      {
        name: translateTransactions('cmd_history'),
        icon: 'footprint',
        action: () =>
          // this.props.openHistory({
          //   page: 'operation_history',
          //   additionalParams: {
          //     OperationID: ID,
          //     HashSum_OperationID_: HashSum_OperationID_, // eslint-disable-line
          //   },
          // }),
          //UPDATED API CALL loan_view_api page: operation_history
          this.props.openHistory({
            page: 'operation_history',
            OperationID: ID,
            HashSum_OperationID_: HashSum_OperationID_,
            ActiveOperFlag: 1,
          }),
      },
      'excelExport',
    ].filter(Boolean)
  }

  deleteTransaction = async ({ ID, hash }: { ID: number; hash: string }) => {
    this.props.deleteTransaction(ID, hash, this.setLoading, this.props.onRefresh, this.props.searchAgainLoans)
  }

  render() {
    const {
      instanceName,
      data,
      switchPage,
      base: { ISO, Amount, FullName, IsArrested, ClientID: clientID, HashSum_ClientID_: clientHash, ProductType },
      ID,
      hash,
    } = this.props

    const onLoanDisburseCallbackActions = [
      this.props.fetchOperations(),
      DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'transactions' }),
      DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }),
    ]

    return (
      <>
        {/* <HistoryModal APICall={Loan.details} /> */}

        {/* UPDATED API CALL loan_view_api page: operation_history  */}
        <HistoryModal action={loanView} />

        <LKModal.Confirmation
          name="DELETE_TRANS_AGREE"
          agreeText={translateLKMessage('MSG_ARE_YOU_SURE')}
          onConfirm={this.deleteTransaction}
          loading={this.state.loading}
          agreeable
          warning
        />

        <LKModal.Confirmation
          name="DELETE_TRANS"
          onConfirm={this.deleteTransaction}
          loading={this.state.loading}
          warning
        />

        <LoanTransactionDisburse callbackActions={onLoanDisburseCallbackActions} />

        <div className="u-flex u-fluid u-directionColumn">
          <div className="u-fluid u-relative">
            <MemoizedLKGrid
              pushOrderDetails={this.pushOrderDetails}
              instanceName={instanceName}
              rowData={data}
              getContextMenuItems={this.getContextMenuItems}
              onRowDoubleClicked={this.onRowDoubleClicked}
              getRowStyle={this.getStylesForRow}
            />
          </div>

          <div className="u-flex u-spaceBetween u-padding-5">
            <LKButton alias="operations" onClick={() => switchPage(pages.operations)}>
              {translator('tb_operations')}
            </LKButton>

            {IsArrested !== 1 && (
              <div>
                <LoanTransactionDisburseTrigger params={{ ID, hash, Amount, ISO, FullName, clientID, clientHash }}>
                  {translateTransactions('cmd_disburse')}
                </LoanTransactionDisburseTrigger>

                <LoanCoverTrigger
                  params={{ ID, hash }}
                  onSuccess={this.props.onLoanDisburseCallbackActions}
                  permission={ProductType === 4 ? 'LOAN_COVER_LMB' : 'LOAN_COVER'}
                >
                  {translateTransactions('cmd_cover')}
                </LoanCoverTrigger>

                <LKGridExportButton alias="export" size="tiny" instanceName={instanceName} />
              </div>
            )}
          </div>
        </div>
      </>
    )
  }
}

export default Transactions
